import { observer } from 'mobx-react';
import { default as React, useContext } from 'react';
import { Container, Table } from 'react-bootstrap';
import { RootStoreContext } from '../../stores/RootStore';
import { costString } from '../../config/Registration';
import moment from 'moment';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './RegistrationHistoryStep.css';

const RegistrationHistoryStep = observer(() => {
  const { registrationStore: { user: { bookingHistory } }, studioConfigStore } = useContext(RootStoreContext);
  const { registrationStore: { clearSelectedItems, toSellingItems } } = useContext(RootStoreContext);
  const currencySymbol = studioConfigStore.currencySymbol;

  const formatCoins = (row: typeof bookingHistory[number]) => {
    if (row.credit) return `+ Ȼ ${row.cost}`;
    if (row.singlePackage) {
      const price = row.packagePrice ?? 0;
      const formatted = Number.isInteger(price) ? price : Number(price).toFixed(2);
      return `${formatted}${currencySymbol}`;
    }
    return `- Ȼ ${row.cost}`;
  };

  const handleHomeClick = () => {
    clearSelectedItems();
    toSellingItems();
  };

  return (
    <Container className="history-container">
      <div className="history-page-header">
        <button
          className="secondary-nav-button"
          onClick={handleHomeClick}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
          <span>Back</span>
        </button>
        <h2 className="history-title">History</h2>
        <div className="history-header-spacer" aria-hidden="true" />
      </div>
      <Table>
        <thead>
          <tr>
            <th>Time</th>
            <th>Coins</th>
            <th>Item</th>
          </tr>
        </thead>
        <tbody>
          {bookingHistory.map((row, index) => (
            <tr key={`history-row-${index}`}>
              <td>{moment(row.time).format('DD.MM.YYYY HH:mm (ddd)')}</td>
              <td>{formatCoins(row)}</td>
              <td>{row.description}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  )
});

export default RegistrationHistoryStep;
